
// Some early tasks requires reading data from server
// But loading jquery early is too slow for mobile devices
// So we have a "lite" version for string values only

// No memoize since it might be called too early
const getDataContainerElement = () => {
  return document.getElementById("app-data-container")
}
// Purpose: get data from body/html

const Retriver = {
  get(name: string): string | null {
    const el = getDataContainerElement()
    if (el == null) { return null }

    return el.getAttribute(`data-${name}`)
  },
}

export default Retriver
